// src/services/vatTuService.js
import api from "@/api"; // Giả sử bạn đã có axios instance

export default {
  getThongKeVatTu(congTrinhId) {
        return api.get(`/api/cong-trinh/${congTrinhId}/thong-ke-vat-tu`);
    },
  // GET: Lấy danh sách vật tư của dự án
  getByCongTrinh(congTrinhId) {
    return api.get(`/api/cong-trinh/${congTrinhId}/vat-tu`);
  },

  // POST: Tạo mới 1 vật tư
  create(congTrinhId, data) {
    return api.post(`/api/cong-trinh/${congTrinhId}/vat-tu`, data);
  },

  // POST: Import nhiều dòng (Excel)
  createBatch(congTrinhId, listData) {
    return api.post(`/api/cong-trinh/${congTrinhId}/vat-tu/batch`, listData);
  },

  // PUT: Cập nhật
  update(id, data) {
    // Lưu ý path này khớp với Controller Backend: @PutMapping("/vat-tu/{id}")
    return api.put(`/api/cong-trinh/vat-tu/${id}`, data);
  },

  // DELETE: Xóa
  delete(id) {
    return api.delete(`/api/cong-trinh/vat-tu/${id}`);
  },
};